export default __webpack_public_path__ + "static/media/talent.3743de95.gif";